export default __webpack_public_path__ + "03ebf51.png";